import css from 'styled-jsx/css';
import { screen } from './variables';

const featuredArticleSummariesCSS = css`
  .featured-article-summaries-container {
    display: flex;
    flex-direction: column;
  }

  .large-article-pane {
    width: 100%;
    margin-bottom: 16px;
  }

  .small-articles-pane {
    width: 100%;
    padding-left: 0;
  }

  @media (min-width: ${screen.mdMin}) {
    .featured-article-summaries-container {
      flex-direction: row;
    }

    .large-article-pane {
      width: 50%;
      margin-bottom: 16px;
    }

    .small-articles-pane {
      height: auto;
      width: 50%;
      display: flex;
      flex-direction: column;
      padding-left: 24px;
    }
  }
`;

export default featuredArticleSummariesCSS;
